// GENERATED FILE, PLEASE DO NOT EDIT
var Alignments = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
  Justify: 'justify'
};
var FontFamilies = {
  TtNorms: 'TTNorms',
  SourceSerifPro: 'SourceSerifPro'
};
var LetterSpacings = {
  400: -0.02,
  500: -0.01,
  600: 0,
  700: 0.01,
  800: 0.02,
  Normal: 0,
  Tight: -0.04,
  Wide: 0.1
};
var LineHeights = {
  100: 8,
  200: 10,
  300: 12,
  400: 14,
  500: 16,
  600: 18,
  700: 20,
  800: 22,
  900: 24,
  1000: 28,
  1100: 32,
  1200: 36,
  1300: 40,
  1400: 44,
  1500: 48,
  1600: 56,
  1700: 64,
  1800: 72,
  1900: 80,
  2000: 96,
  XSmall: 0.8,
  Small: 1,
  Medium: 1.25,
  Large: 1.5,
  S10: 1.6,
  S12: 1.5,
  S14: 1.4285714286,
  S16: 1.375,
  S18: 1.333,
  S22: 1.3636,
  S24: 1.333,
  S32: 1.25,
  S40: 1.2
};
var LineBreakModes = {
  Truncate: 'truncate',
  Wrap: 'wrap'
};
var Sizes = {
  100: 8,
  200: 10,
  300: 12,
  400: 14,
  500: 16,
  600: 18,
  700: 20,
  800: 22,
  900: 24,
  1000: 32,
  1100: 40,
  1200: 48,
  1300: 56,
  1400: 64,
  1500: 72,
  1600: 80,
  S10: 10,
  S16: 16,
  S12: 12,
  S18: 18,
  S14: 14,
  S22: 22,
  S24: 24,
  S32: 32,
  S40: 40
};
var TextTransforms = {
  UpperCase: 'uppercase',
  Normal: 'none'
};
var Weights = {
  100: 'Thin',
  200: 'ExtraLight',
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'DemiBold',
  700: 'Bold',
  800: 'ExtraBold',
  900: 'Black',
  Thin: '200',
  Light: '300',
  Regular: '400',
  Medium: '500',
  Bold: '700',
  ExtraBold: '800'
};

export { Alignments, FontFamilies, LetterSpacings, LineBreakModes, LineHeights, Sizes, TextTransforms, Weights };
